import React from "react"
import { AppFunctionComponent } from "../../../types"
import Breadcrumbs from "../../components/breadcrumbs/breadcrumbs.component"
import { connect } from "react-redux"
import { RootState } from "../../../store"
import { getBreadcrumbs } from "../../selectors/breadcrumbs-from-route.selector"
import { isCurrentPageALocale } from "../../helpers/is-current-page-a-locale"
import { useSelector } from "react-redux"

const mapStateToProps = (state: RootState) => {
  return {
    breadcrumbs: getBreadcrumbs(state),
  }
}

type StateProps = ReturnType<typeof mapStateToProps>

const DetectedBreadcrumbs: AppFunctionComponent<StateProps> = ({
  breadcrumbs,
}) => {
  const currentPage = useSelector(
    (state: RootState) => state.router.location?.pathname
  )
  if (isCurrentPageALocale(currentPage!)) {
    return null
  }

  return <Breadcrumbs links={breadcrumbs} />
}

export default connect(mapStateToProps)(DetectedBreadcrumbs)
